"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return CalendarView;
    }
});
const _extractProps = require("~/helpers/extractProps");
const _modelUtils = require("~/utils/modelUtils");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _CalendarRange = /*#__PURE__*/ _interop_require_default(require("~/models/CalendarRange"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let CalendarView = class CalendarView {
    static async get(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let view = viewId && await _NocoCache.default.get(context, `${_globals.CacheScope.CALENDAR_VIEW}:${viewId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (view) {
            const calendarRange = await _CalendarRange.default.read(context, viewId, ncMeta);
            if (calendarRange) {
                view.calendar_range = calendarRange.ranges;
            } else {
                view.calendar_range = [];
            }
        } else {
            view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW, {
                fk_view_id: viewId
            });
            const calendarRange = await _CalendarRange.default.read(context, viewId, ncMeta);
            if (view && calendarRange) {
                view.calendar_range = calendarRange.ranges;
            }
            await _NocoCache.default.set(context, `${_globals.CacheScope.CALENDAR_VIEW}:${viewId}`, view);
        }
        return view && new CalendarView(view);
    }
    static async insert(context, view, ncMeta = _Noco.default.ncMeta) {
        const insertObj = {
            base_id: view.base_id,
            source_id: view.source_id,
            fk_view_id: view.fk_view_id,
            meta: view.meta
        };
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW, insertObj, true);
        return this.get(context, view.fk_view_id, ncMeta);
    }
    static async update(context, calendarId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'fk_cover_image_col_id',
            'meta'
        ]);
        if (body.calendar_range) {
            await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, {
                fk_view_id: calendarId
            });
            // if calendar range is updated, delete cache
            await _NocoCache.default.del(context, `${_globals.CacheScope.CALENDAR_VIEW}:${calendarId}`);
            await _CalendarRange.default.bulkInsert(context, body.calendar_range.map((range)=>{
                return _extends({
                    fk_view_id: calendarId
                }, range);
            }), ncMeta);
        }
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW, (0, _modelUtils.prepareForDb)(updateObj), {
            fk_view_id: calendarId
        });
        // update cache
        await _NocoCache.default.update(context, `${_globals.CacheScope.CALENDAR_VIEW}:${calendarId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
